import i18n from 'i18next'

export const titleUndeletableObservation = (
  trainingIds: number[],
  testIds: number[]
) => {
  if (trainingIds.length === 0 && testIds.length === 0) {
    return ''
  }

  const trainingMessage = () => {
    if (trainingIds.length === 0) return ''
    if (trainingIds.length === 1)
      return `${i18n.t('in training')} ${idsToString(trainingIds)}`
    return `${i18n.t('in trainings')} ${idsToString(trainingIds)}`
  }

  const testMessage = () => {
    if (testIds.length === 0) return ''
    if (testIds.length === 1)
      return `${i18n.t('in test')} ${idsToString(testIds)}`
    return `${i18n.t('in tests')} ${idsToString(testIds)}`
  }

  const training = trainingMessage()
  const test = testMessage()

  if (training && test) {
    return `${i18n.t(
      'Image cannot be deleted since used'
    )} ${training} ${i18n.t('and')} ${test}`
  }
  return `${i18n.t('Image cannot be deleted since used')} ${training}${test}`
}

export const titleUneditableObservation = (trainingIds: number[]) => {
  if (trainingIds.length === 0) return ''
  if (trainingIds.length === 1)
    return `${i18n.t('Image cannot be changed since used')} ${i18n.t(
      'in training'
    )} ${idsToString(trainingIds)}`
  return `${i18n.t('Image cannot be changed since used')} ${i18n.t(
    'in trainings'
  )} ${idsToString(trainingIds)}`
}

const idsToString = (ids: number[]) => {
  if (ids.length === 0) return ''
  return `#${ids.join(', #')}`
}
